// Vendor imports
const _ = require('lodash')
const qs = require('qs')
const { createSelector } = require('reselect')

module.exports = {
  isInternalHref,
  normalizeExternalHref,
  normalizeInternalHref
}

// External HREF handling

const URL_PROTOCOL_REGEXP = /^(https?:\/\/)?(.*)/

function normalizeExternalHref(url) {
  // Ensure the URL has a protocol (default to http://)
  const match = URL_PROTOCOL_REGEXP.exec(url || '')
  if (match) {
    return (match[1] || 'http://') + match[2]
  }
}

// Internal HREF handling

let currentBaseUrl
if (typeof window !== 'undefined') {
  currentBaseUrl = createSelector(
    () => window.location.href,
    href => {
      const { pathname, search } = window.location
      const pathPos = href.lastIndexOf(pathname + search)
      return href.substr(0, pathPos) + '/'
    }
  )
}

function isInternalHref(href) {
  // Check for path URIs with no scheme/authority component
  if (/^\/[^/]/.test(href)) {
    return true
  }
  // Check against the current base URL
  if (currentBaseUrl) {
    return href.startsWith(currentBaseUrl())
  }
  return false
}

const PROPAGATE_QUERY_KEYS = ['native', 'render']

function normalizeInternalHref(href) {
  if (typeof window === 'undefined' || !isInternalHref(href)) {
    return href
  }
  // Parse, then strip away the query parameters from the href
  let hrefQuery = {}
  let hrefBase = href
  const hrefQueryPos = href.indexOf('?')
  if (hrefQueryPos > -1) {
    hrefQuery = qs.parse(href.substr(hrefQueryPos + 1))
    hrefBase = href.substr(0, hrefQueryPos)
  }
  const currentQuery = qs.parse(window.location.search, { ignoreQueryPrefix: true })
  // Propagate current "magic" query parameters to the next page
  const propagateQuery = _.pick(currentQuery, PROPAGATE_QUERY_KEYS)
  const combinedQueryString = qs.stringify({ ...propagateQuery, ...hrefQuery })
  if (combinedQueryString) {
    return `${hrefBase}?${combinedQueryString}`
  }
  return href
}
